import React from "react";

import cartIcon from "images/cart-icon.svg";

const CartIcon = () => <img src={cartIcon} alt="Cart Icon" />;

export default CartIcon;
